import { ActionMenuItem } from '@shared/components/action-menu/action-menu-item.model';
import { CHECK_PERMISSIONS } from '@shared/modules/permissions.module';
import { CompanyActions } from './company-actions-enum';
import { useActionMenuComposable } from '@shared/components/action-menu/action-menu-composable';

export const useCompanyActionMenu = () => {
  // Composable logic for navigation menu can be added here
  const validatePermission = CHECK_PERMISSIONS();
  const actionMenuHelper = useActionMenuComposable();
  const companyActionMenuItems: ActionMenuItem[] = [
    {
        title:'Details',
        icon:'info',
        route:'/companies',
        validPermission: validatePermission.canReadCompanies(),
        action: CompanyActions.PageChange,
    },
    {
        title:'Deactivate',
        statefulTitle: actionMenuHelper.getTruthyStatefulTitle,
        icon:'block',
        route:'/companies',
        validPermission: validatePermission.canReadCompanies(),
        action: CompanyActions.Toggled,
    },
  ];
  return{
    companyActionMenuItems
  }
};
